import React from 'react';
import Icon from '../../../components/AppIcon';

const ProfileScoreChart = ({ analysisHistory, trend }) => {
  const getTrendIcon = () => {
    if (trend === 'improving') return { name: 'TrendingUp', color: '#10B981' };
    if (trend === 'declining') return { name: 'TrendingDown', color: '#EF4444' };
    return { name: 'Minus', color: '#F59E0B' };
  };

  const getTrendText = () => {
    if (trend === 'improving') return 'Your scores are improving!';
    if (trend === 'declining') return 'Scores declining - time to optimize';
    return 'Scores are stable';
  };

  const trendIcon = getTrendIcon();
  const maxScore = Math.max(...analysisHistory?.map(s => s?.highestScore));
  const minScore = Math.min(...analysisHistory?.map(s => s?.averageScore));
  const scoreRange = maxScore - minScore;

  return (
    <div className="bg-card rounded-xl p-4 sm:p-6 border border-border">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-5 sm:mb-6">
        <div className="flex-1">
          <h3 className="text-lg sm:text-xl font-semibold text-foreground mb-2">Score Progression</h3>
          <div className="flex items-center gap-2">
            <Icon name={trendIcon?.name} size={20} color={trendIcon?.color} />
            <span className="text-sm sm:text-base font-medium" style={{ color: trendIcon?.color }}>
              {getTrendText()}
            </span>
          </div>
        </div>
        <div className="text-left sm:text-right">
          <div className="text-3xl sm:text-2xl font-bold text-foreground">
            {analysisHistory?.[0]?.averageScore?.toFixed(1)}
          </div>
          <div className="text-xs sm:text-xs text-muted-foreground">Current Avg</div>
        </div>
      </div>

      {/* Simple bar chart visualization - Mobile Optimized */}
      <div className="space-y-3 sm:space-y-4">
        {analysisHistory?.map((session, index) => {
          const barHeight = scoreRange > 0 ? ((session?.averageScore - minScore) / scoreRange) * 100 : 50;
          return (
            <div key={index} className="flex items-center gap-2 sm:gap-4">
              <div className="text-xs sm:text-xs text-muted-foreground w-16 sm:w-20 flex-shrink-0">
                {new Date(session?.date)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}
              </div>
              <div className="flex-1 bg-muted rounded-full h-10 sm:h-8 relative overflow-hidden min-h-[44px] sm:min-h-[32px]">
                <div
                  className="bg-gradient-to-r from-purple-600 to-cyan-500 h-full rounded-full transition-all duration-500 flex items-center justify-end pr-2 sm:pr-3"
                  style={{ width: `${Math.max(barHeight, 20)}%` }}
                >
                  <span className="text-xs sm:text-xs font-semibold text-white">
                    {session?.averageScore?.toFixed(1)}
                  </span>
                </div>
              </div>
              <div className="text-xs text-muted-foreground w-14 sm:w-16 text-right">
                {session?.photoCount} photos
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProfileScoreChart;